The identifier for the `Attachment`.

This is unique across all attachments.
